import type { PageCursorZone } from '@teo/widget-shared';

/** Map viewport Y to top / middle / bottom band. */
export function resolveCursorZone(
  clientY: number,
  viewportHeight: number,
): PageCursorZone {
  if (viewportHeight <= 0) return 'middle';
  const ratio = clientY / viewportHeight;
  if (ratio < 1 / 3) return 'top';
  if (ratio < 2 / 3) return 'middle';
  return 'bottom';
}
